import { AppyError } from '../../../../../../../../../../Appy';
import { MissingLinkError } from '../../../../../../../../../../LinkyLinky';
import { ProgramFamilyShareUrlResource } from '../../../../../../../../Types';

export interface Ready {
  kind: 'ready';
  shareUrlResource: ProgramFamilyShareUrlResource;
}

export interface Deactivating {
  kind: 'deactivating';
  shareUrlResource: ProgramFamilyShareUrlResource;
}

export interface Activating {
  kind: 'activating';
  shareUrlResource: ProgramFamilyShareUrlResource;
}

export interface Error {
  kind: 'error';
  error: ShareUrlError;
  shareUrlResource: ProgramFamilyShareUrlResource;
}

export type ShareUrlError = AppyError | MissingLinkError;

export type State = Ready | Deactivating | Error | Activating;

export const ready = (shareUrlResource: ProgramFamilyShareUrlResource): Ready => ({
  kind: 'ready',
  shareUrlResource,
});

export const deactivating = (state: Ready): Deactivating => ({
  kind: 'deactivating',
  shareUrlResource: state.shareUrlResource,
});

export const activating = (state: Ready): Activating => ({
  kind: 'activating',
  shareUrlResource: state.shareUrlResource,
});

export const error = (error: ShareUrlError, state: Ready | Deactivating | Activating): Error => ({
  kind: 'error',
  shareUrlResource: state.shareUrlResource,
  error,
});
